import React, { useEffect } from "react";
import { Formik } from "formik";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { compact, isEmpty } from "lodash-es";

// Helpers
import { initialValues } from "../../../helpers/tracking/initialValues";
import { trackingValidationSchema } from "../../../helpers/tracking/validationSchema";
import { cleanTrackingCodes } from "../../../helpers/tracking/formService";

// Components
import { trackingViews } from "../../../constants/tracking";
import NewTrackingForm from "./NewTrackingForm";
// import DebugFormikState from "../../formik/FormikState";

const FormInner = styled.div`
  padding: 18px;
  background-color: #333333;
  @media screen and (min-width: 576px) {
    padding: 32px;
  }
  @media screen and (min-width: 992px) {
    padding: 33px 53px 45px 48px;
  }
`;

const TrackingFormParent = ({
  setActiveView = () => {},
  setBarcodes = () => {},
}) => {
  const history = useHistory();
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const barcodesParams = params.get("barcodes");
    if (barcodesParams) {
      const barcodes = barcodesParams.split(",");
      if (!isEmpty(compact(barcodes))) {
        setActiveView(trackingViews.trackingResults);
      }
    }
  }, [search, setActiveView]);

  const onSubmit = async (values) => {
    const currentRoute = history.location.pathname.includes("account-tracking")
      ? "/account-tracking"
      : "/tracking";

    return history.push(
      `${currentRoute}?barcodes=${cleanTrackingCodes(
        values.trackingNumbers.map(({ value }) => value)
      )}`
    );
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={trackingValidationSchema}
    >
      {() => {
        return (
          <>
            <FormInner>
              <NewTrackingForm />
              {/* <DebugFormikState /> */}
            </FormInner>
          </>
        );
      }}
    </Formik>
  );
};

export default TrackingFormParent;
